import {useThemeContext} from "../../../../../../branding/context/ThemeProvider";
import {ResponsiveBar} from "@nivo/bar";
import ChartToolTip from "./ChartToolTip";


const SingleProductSalesChart = ({ data, scaleHeight }) => {

    const theme = useThemeContext();

    const stackedData = data.map((d) => {
        return {
            period: d.period,
            Sales: d.Sales,
            total: d.total - d.Sales,
            "Prev. Period": d.last_period_sales
        };
    });

    const getToolTipText = ({id, value, data}) => `${id}: ${value} for ${data.period}`;

    const keys = [ 'Sales', 'Prev. Period' ];

    return (
        <ResponsiveBar
            maxValue={scaleHeight}
            data={stackedData}
            keys={keys}
            indexBy="period"
            groupMode="grouped"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={({ id }) => {
                if (id === 'Sales') return theme.colour.secondary;
                if (id === 'Prev. Period') return theme.colour.secondaryMuted;
                return theme.colour.tertiary;
            }}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -45,
                legendPosition: 'middle',
                legendOffset: 32,
                truncateTickAt: 0
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Units Sold',
                legendPosition: 'middle',
                legendOffset: -40,
                truncateTickAt: 0
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
            role="application"
            ariaLabel="Nivo bar chart demo"
            barAriaLabel={e=> `${e.id}: ${e.formattedValue} for period: ${e.indexValue}`}
            label={bar => `${bar.value}`}
            tooltip={(e) => (
                <ChartToolTip >
                    {getToolTipText(e)}
                </ChartToolTip>
            )}
        />
    )

}

export default SingleProductSalesChart;
